module.exports = __webpack_public_path__ + "static/media/achievement-25.5edadb8d.png";